<box size="sm">
  <app-header [title]="'ship_interface.create_new_noon_report' | transloco" [onClose]="onClosePress"></app-header>
  <app-body>
    <div>
      @if (!isEmpty(previousNoonReport())) {
        <div class="px-9 py-3">
          <div class="font-semibold">{{ 'ship_interface.latest_noon_report_submitted' | transloco }}</div>
          <div class="mt-2 text-2xl font-semibold text-primary">{{ previousTitleReport }}</div>
          <div class="mt-[2px] inline-flex items-center font-medium italic text-gray-500">
            {{ 'ship_interface.press_copy_button' | transloco }}<mat-icon [svgIcon]="'heroicons_outline:copy'" class="icon-copy-size mx-[2px]"></mat-icon
            >{{ 'ship_interface.to_import_data_field_from_last_submitted_report' | transloco }}
          </div>
        </div>
      }
      <div class="flex flex-row gap-2 px-9 py-3">
        <form-date-picker
          [label]="'ship_interface.report_date' | transloco"
          [required]="true"
          class="w-full"
          [control]="form.get('date_report')"></form-date-picker>
        <textbox
          [label]="'ship_interface.current_voyage_number' | transloco"
          [required]="true"
          [placeholder]="'ship_interface.enter_voyage_number' | transloco"
          class="w-full"
          [control]="form.get('voyage_number')"></textbox>
      </div>
      <selection-button
        [label]="'ship_interface.select_noon_report_type' | transloco"
        [required]="true"
        [buttons]="buttons()"
        (buttonsChange)="onButtonsChange($event)">
      </selection-button>
    </div>
  </app-body>
  <app-footer
    [saveButtonTitle]="'button.next' | transloco"
    [onSave]="null"
    [onDiscard]="onDiscard"
    [disabledSaveButton]="form.invalid"
    [hasSaveButton]="['noon_report_ship_interface', ['create']] | permission"
    (save)="onSavePress()"></app-footer>
</box>
